import { capitalizeSpanish } from "#core/functions/string"
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp"
import { Stack } from "@mui/material"
import MuiAccordion from "@mui/material/Accordion"
import MuiAccordionDetails from "@mui/material/AccordionDetails"
import MuiAccordionSummary, {
	accordionSummaryClasses,
} from "@mui/material/AccordionSummary"
import { styled } from "@mui/material/styles"
import Typography from "@mui/material/Typography"
import { useEffect, useState } from "react"

const AccordionStyle = styled((props) => (
	<MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
	border: `1px solid ${theme.palette.divider}`,
	"&:not(:last-child)": {
		borderBottom: 0,
	},
	"&::before": {
		display: "none",
	},
}))

const AccordionSummary = styled((props) => (
	<MuiAccordionSummary
		expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
		{...props}
	/>
))(({ theme }) => ({
	backgroundColor: "rgba(0, 0, 0, .03)",
	flexDirection: "row-reverse",
	minHeight: "32px",
	"&.Mui-expanded": {
		minHeight: "32px",
	},
	[`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]:
		{
			transform: "rotate(90deg)",
		},
	[`& .${accordionSummaryClasses.content}`]: {
		marginLeft: theme.spacing(1),
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(1),
	},
	...theme.applyStyles("dark", {
		backgroundColor: "rgba(255, 255, 255, .05)",
	}),
}))

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
	padding: theme.spacing(0),
	borderTop: "2px solid rgba(0, 0, 0, .125)",
}))

const CustomAccordion = styled(AccordionStyle)(({ theme }) => ({
	// borderRadius: theme.shape.borderRadius * 2, // 16px si el default es 8px
	boxShadow: theme.shadows[1],
	overflow: "hidden",
	backgroundColor: "white",
}))

export default function AccordionMain({ items, getSelect }) {
	const [expanded, setExpanded] = useState("")
	// useEffect(() => {
	// 	if (typeof getSelect !== "function") return
	// 	getSelect(expanded)
	// }, [expanded, getSelect])

	const handleChange = (panel) => (event, newExpanded) => {
		const selectExpande = newExpanded ? panel : false
		setExpanded(selectExpande)
		if (typeof getSelect !== "function") return
		getSelect(selectExpande)
	}

	const itemsArray = items.map((item, index) => {
		const label = capitalizeSpanish(item.label)
		return (
			<AccordionItems
				key={item.id}
				id={item.id}
				label={label}
				expanded={expanded}
				component={item.component}
				onChange={handleChange(item.id)}
			/>
		)
	})

	return <Stack spacing={1}>{itemsArray}</Stack>
}

const AccordionItems = ({ id, label, component, expanded, onChange }) => {
	return (
		<CustomAccordion expanded={expanded === id} onChange={onChange}>
			<AccordionSummary>
				<Typography
					variant="body1"
					fontWeight="600"
					color="text.primary"
					sx={{
						textTransform: "capitalize",
					}}
				>
					{label}
				</Typography>
			</AccordionSummary>
			<AccordionDetails>{component}</AccordionDetails>
		</CustomAccordion>
	)
}
